export function isTouchDevice() {
    return (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    // @ts-expect-error undefined
    (navigator.msMaxTouchPoints > 0));
}